import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Lottie from "react-lottie";
import loading from "./loading.json";
import { Helmet } from "react-helmet-async";
import useFetch from "../hooks/useFetch.js";
import AcademySection1 from "../pages/AcademySection1.js";
import AcademySection2 from "../pages/AcademySection2.js";
import AcademySection3 from "../pages/AcademySection3.js";
import AcademySection4 from "../pages/AcademySection4.js";
import AcademySection5 from "../pages/AcademySection5.js";

const AcademyContent = () => {
  const { slug } = useParams();
  const [academy, setAcademy] = useState(null);

  const {
    loading: academyLoading,
    data: academyData,
    error: academyError,
  } = useFetch(
    `https://devrw2.blob.core.windows.net/rw-website/strapi-data/academy/data.json`
  );

  useEffect(() => {
    if (academyData && Array.isArray(academyData)) {
      const foundAcademy = academyData.find(
        (item) =>
          item.academyTitle
            .toLowerCase()
            .replace(/[^\w\s-]/g, "")
            .replace(/[\s_-]+/g, "-")
            .replace(/^-+|-+$/g, "") === slug
      );
      setAcademy(foundAcademy);
    }
  }, [academyData, slug]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loading,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (academyLoading || !academy) {
    return (
      <div className="w-full flex justify-center items-center min-h-screen">
        <Lottie options={defaultOptions} height={400} width={400} />
      </div>
    );
  }

  return (
    <div className=" font-display mt-16">
      <AcademySection1 academy={academy} />
      <AcademySection2 academy={academy} />
      <div className="border-t border-b-gray-100 border border-gray-100 mt-2"></div>
      <AcademySection3 academy={academy} />

      <AcademySection4 academy={academy} />
      <div className="border-t border-b-gray-100 border border-gray-100 mt-2"></div>
      <AcademySection5 academy={academy} />
    </div>
  );
};

export default AcademyContent;
